import React from 'react';

/**
 * A numbered section head. The numbers are not decoration — they map to the
 * options in the USSD menu in the hero, so "2." is the same destination on the
 * page as pressing 2 on the handset.
 */
function Section({ number, title, aside, children, id, className = '' }) {
  return (
    <section id={id} className={`scroll-mt-24 ${className}`}>
      <div className="flex items-end justify-between gap-6 border-b border-rule pb-4">
        <h2 className="flex items-baseline gap-3 text-headline">
          {number && <span className="font-mono text-signal text-base tabular-nums">{number}.</span>}
          <span>{title}</span>
        </h2>
        {aside && <div className="label shrink-0 pb-1.5">{aside}</div>}
      </div>
      {children}
    </section>
  );
}

export default Section;
